import React from "react";
import { Container, TextContainer, IconContainer } from "./styled-components";
import Text from "../text";
import { StepCardProps } from "./types";

const StepCard = ({ step, title, icon, color }: StepCardProps) => {
  return (
    <Container color={color}>
      <TextContainer>
        <Text size="18px" weight={600} lineHeight="28px">
          {step}
        </Text>
        <Text size="24px" lineHeight="32px" weight={700}>
          {title}
        </Text>
      </TextContainer>
      {icon && <IconContainer>{icon}</IconContainer>}
    </Container>
  );
};

export default StepCard;
